import { getI18n } from 'client/i18n'
import { AMOUNT_TYPES } from 'shared/shared_consts'
import EditMain from './edit_main'
import { connect } from 'react-redux'
import { formatMoney } from 'client/griffin'
import { show as showComingSoon } from 'redux/modules/coming_soon_dialog'
import { getCampaignSelector } from 'redux/selectors/campaign'

const i18n = getI18n('components/edit_glimpse/edit_main')

function stringifyContributionPrefs(campaign) {
  switch (campaign.amount_type) {
    case AMOUNT_TYPES.any:
      return i18n('any')
    case AMOUNT_TYPES.at_least:
      return i18n('at_least', {
        amount: formatMoney(campaign.currency, campaign.amount),
      })
    case AMOUNT_TYPES.exactly:
      return i18n('exactly', {
        amount: formatMoney(campaign.currency, campaign.amount),
      })
    default:
      return 'UNKNOWN'
  }
}

function stringifyPublicTrackingPrefs(campaign) {
  let octal =
    (campaign.share_progress ? 1 : 0) +
    (campaign.share_contributors ? 2 : 0) +
    (campaign.share_progress && campaign.share_contributions ? 4 : 0)

  return i18n('tracking_prefs_' + octal)
}

const mapStateToProps = (state, props) => {
  const campaign = getCampaignSelector(state, props)
  return {
    title: campaign.title,
    backgroundImage: campaign.background_image,
    gradientColor: campaign.gradient_color,
    backgroundPan: campaign.background_pan,
    goal: campaign.goal ? campaign.goal : undefined,
    endDate: campaign.end_date ? new Date(campaign.end_date) : undefined,
    ended: !campaign.can_chip_in,
    description: campaign.description,
    contribPrefs: stringifyContributionPrefs(campaign),
    tracking: stringifyPublicTrackingPrefs(campaign),
    currency: campaign.currency,
    showDelete: !campaign.preview,
    isAndroid:
      state.device_info.isMobile && state.device_info.deviceOS === 'Android',
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onReopen() {
      dispatch(showComingSoon())
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditMain)
